import { render, staticRenderFns } from "./EditAddAlias.vue?vue&type=template&id=66428ec0&scoped=true&"
import script from "./EditAddAlias.vue?vue&type=script&lang=js&"
export * from "./EditAddAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66428ec0",
  null
  
)

export default component.exports